import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const errorBodySchema = z.object({ message: z.string() });

const fhirIdSchema = z.string().regex(/^[A-Za-z0-9\-.]{1,64}$/);

export const externalOrganizationRoleSchema = z.enum(['payer']);
export type ExternalOrganizationRole = z.infer<
  typeof externalOrganizationRoleSchema
>;

export const externalOrganizationSchema = z.object({
  id: fhirIdSchema,
  role: externalOrganizationRoleSchema,
  name: z.string(),
  aliases: z.array(z.string()),
  active: z.boolean(),
});
export type ExternalOrganization = z.infer<typeof externalOrganizationSchema>;

export const externalOrganizationNameCheckSchema = z.discriminatedUnion(
  'available',
  [
    z.object({ available: z.literal(true) }),
    z.object({
      available: z.literal(false),
      clash: z.string(),
      ownerId: fhirIdSchema,
      ownerName: z.string(),
    }),
  ],
);
export type ExternalOrganizationNameCheck = z.infer<
  typeof externalOrganizationNameCheckSchema
>;

export const externalOrganizationsContract = c.router(
  {
    checkExternalOrganizationNames: {
      method: 'POST',
      path: 'name-check',
      body: z.object({
        role: externalOrganizationRoleSchema,
        names: z.array(z.string().min(1).max(120)).min(1).max(21),
        exceptOrganizationId: fhirIdSchema.nullable(),
      }),
      responses: {
        200: externalOrganizationNameCheckSchema,
        409: errorBodySchema,
      },
      summary: 'Is this name (or alias) already taken by another organization?',
    },
  },
  {
    pathPrefix: '/:tenantId/external-organizations/',
    pathParams: z.object({
      tenantId: z.string().uuid(),
    }),
  },
);
